import { Component } from "@opten/compiler/metadata/component";

@Component({ className: "js-pagination" })
export class PaginationComponent {
	constructor(private element: HTMLElement) {
		const loadMore = document.querySelector(".js-load-more") as HTMLElement;
		const incrementAmount = 5;
		let currentLimit = 5;

		var mixer = mixitup(this.element, {
			pagination: {
				limit: currentLimit,
			},
			callbacks: {
				onMixEnd: (state) => {
					if (loadMore) {
						if (
							state.activePagination.limit >= state.totalMatching
						) {
							loadMore.classList.add("d-none");
						} else {
							loadMore.disabled = false;
						}
					}
				},
			},
		});

		if (loadMore) {
			loadMore.addEventListener("click", () => {
				currentLimit += incrementAmount;
				mixer.paginate({ limit: currentLimit });
			});
		}
	}
}
